var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { useMap } from 'react-map-gl';
import styled, { css } from 'styled-components';
import { MapButton } from '../MapButton';
var CompassButtonBase = function (p) {
    var map = useMap().current;
    return (React.createElement(MapButton, __assign({ onClick: function () { map.rotateTo(0); map.resetNorthPitch(); } }, p),
        React.createElement("div", { style: { transform: "rotateX(".concat(p.visualizePitch ? p.pitch : 0, "deg)") } },
            React.createElement("svg", { style: { transform: "rotateZ(".concat(-p.bearing, "deg)") }, xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 1000 1000" },
                React.createElement("polygon", { className: "tip", points: "100,1000 500,0 900,1000 500,700 " }),
                React.createElement("polygon", { className: "arrow", points: "500,0 423,192.6 500,351.6 577,192.6 " })))));
};
var CompassButtonStyled = styled(CompassButtonBase)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  /* Add custom tip color if specified. */\n  ", "\n"], ["\n  /* Add custom tip color if specified. */\n  ", "\n"
    /**
     * The `CompassButton` shows a bearing arrow which points to the north.
     * It optionally tilts the arrow to reflect the current pitch.
     *
     * The current map ViewState must be passed to this control.
     *
     * @example
     * ```tsx
     * <CompassButton
     *   skin={DarkSkin} {...this.state.viewState} x={40} y={500}
     *   hint={<>Reset bearing to north</>} visualizePitch contrastTip />
     * ```
     */
])), function (p) { return p.contrastTip && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    svg polygon.arrow {\n      fill: ", ";\n    }"], ["\n    svg polygon.arrow {\n      fill: ", ";\n    }"])), typeof p.contrastTip === "string" ? p.contrastTip : "red"); });
/**
 * The `CompassButton` shows a bearing arrow which points to the north.
 * It optionally tilts the arrow to reflect the current pitch.
 *
 * The current map ViewState must be passed to this control.
 *
 * @example
 * ```tsx
 * <CompassButton
 *   skin={DarkSkin} {...this.state.viewState} x={40} y={500}
 *   hint={<>Reset bearing to north</>} visualizePitch contrastTip />
 * ```
 */
var CompassButton = function (p) { return React.createElement(CompassButtonStyled, __assign({}, p)); };
export { CompassButton };
var templateObject_1, templateObject_2;
